module.exports = __webpack_public_path__ + "assets/img/8@3x.0e682b76.png";